// 初始化拖拽功能的核心逻辑
function initDrag(el) {
  const dialogHeaderEl = el.querySelector('.el-dialog__header')
  const dragDom = el.querySelector('.el-dialog')

  if (!dialogHeaderEl || !dragDom) {
    // dialog 可能还未渲染，稍后重试
    return false
  }

  // 检查是否已经初始化过，避免重复绑定
  if (dialogHeaderEl.__dragInitialized__) {
    return true
  }

  dialogHeaderEl.style.cursor = 'move'

  // 禁用用户选择，避免拖拽时选中文本
  dialogHeaderEl.style.userSelect = 'none'
  dialogHeaderEl.style.webkitUserSelect = 'none'
  dialogHeaderEl.style.mozUserSelect = 'none'
  dialogHeaderEl.style.msUserSelect = 'none'

  // 定义 mousedown 处理函数
  const handleMouseDown = e => {
    // 兼容性处理：确保事件对象存在
    e = e || window.event

    // 阻止默认行为和事件冒泡 不能阻止冒泡 确认事件会丢失
    // e.preventDefault()
    // e.stopPropagation()

    const disX = e.clientX - dragDom.offsetLeft
    const disY = e.clientY - dragDom.offsetTop

    const handleMouseMove = e => {
      e = e || window.event
      e.preventDefault()
      e.stopPropagation()

      const left = e.clientX - disX
      const top = e.clientY - disY

      dragDom.style.position = 'fixed'
      dragDom.style.left = left + 'px'
      dragDom.style.top = top + 'px'
      dragDom.style.marginTop = '0'
    }

    const handleMouseUp = () => {
      document.removeEventListener('mousemove', handleMouseMove)
      document.removeEventListener('mouseup', handleMouseUp)
    }

    document.addEventListener('mousemove', handleMouseMove)
    document.addEventListener('mouseup', handleMouseUp)
  }

  // 绑定事件监听器
  dialogHeaderEl.addEventListener('mousedown', handleMouseDown)

  // 标记已初始化，并存储处理函数以便后续清理
  dialogHeaderEl.__dragInitialized__ = true
  dialogHeaderEl.__dragMouseDownHandler__ = handleMouseDown

  return true
}

// 清理拖拽功能
function cleanupDrag(el) {
  const dialogHeaderEl = el.querySelector('.el-dialog__header')
  if (dialogHeaderEl && dialogHeaderEl.__dragMouseDownHandler__) {
    dialogHeaderEl.removeEventListener(
      'mousedown',
      dialogHeaderEl.__dragMouseDownHandler__
    )
    delete dialogHeaderEl.__dragInitialized__
    delete dialogHeaderEl.__dragMouseDownHandler__
  }

  // 清理可能残留的 document 事件监听器
  document.onmousemove = null
  document.onmouseup = null
}

export default {
  bind(el) {
    // 首次绑定时尝试初始化
    initDrag(el)
  },

  inserted(el) {
    // 元素插入 DOM 后再次尝试初始化
    // 使用 nextTick 确保 el-dialog 内部元素已完全渲染
    setTimeout(() => {
      initDrag(el)
    }, 0)
  },

  update(el) {
    // 每次更新时检查是否需要重新初始化
    // 这对于 destroy-on-close 的场景很重要
    setTimeout(() => {
      const dialogHeaderEl = el.querySelector('.el-dialog__header')
      if (dialogHeaderEl && !dialogHeaderEl.__dragInitialized__) {
        initDrag(el)
      }
    }, 0)
  },

  componentUpdated(el) {
    // 组件更新后检查是否需要初始化
    setTimeout(() => {
      const dialogHeaderEl = el.querySelector('.el-dialog__header')
      if (dialogHeaderEl && !dialogHeaderEl.__dragInitialized__) {
        initDrag(el)
      }
    }, 0)
  },

  unbind(el) {
    // 清理事件监听器
    cleanupDrag(el)
  }
}
